/**
 * TODO #mz ADD I18N support
 * */
export const PRIZM_CRON_UI_MONTH_CRON_KEYS = [
  'JAN',
  'FEB',
  'MAR',
  'APR',
  'MAY',
  'JUN',
  'JUL',
  'AUG',
  'SEP',
  'OCT',
  'NOV',
  'DEC',
] as const;

export const PRIZM_CRON_UI_DAYS_OF_WEEK_CRON_KEYS = [
  'SUN',
  'MON',
  'TUE',
  'WED',
  'THU',
  'FRI',
  'SAT',
] as const;
